import * as constants from '../constants/actions';

const initialState = {
  alertOpen: false,
  alertText: '',
  alertPrompt: null,
  modalResize: 0,
  contactOpen: false,
  contactNoItemOpen: false,
  contactProduct: null,
  inviteOpen: false,
  contactSent: false,
  lastPageVisited: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.COMMON_ALERT:
      return commonOpenAlert(state, action);
    case constants.COMMON_CLOSE_ALERT:
      return commonCloseAlert(state, action);
    case constants.COMMON_MODAL_RESIZE:
      return commonModalResize(state, action);
    case constants.COMMON_OPEN_CONTACT:
      return commonOpenContact(state, action);
    case constants.COMMON_CLOSE_CONTACT:
      return commonCloseContact(state, action);
    case constants.COMMON_OPEN_INVITE:
      return commonOpenInvite(state, action);
    case constants.COMMON_CLOSE_INVITE:
      return commonCloseInvite(state, action);
    case constants.COMMON_CONTACT_SENT:
      return commonContactSent(state, action);
    case constants.COMMON_SET_LAST_VISITED:
      return commonSetLastVisited(state, action);
    case constants.COMMON_OPEN_NO_ITEM_CONTACT:
      return commonOpenNoItemContact(state, action);
    case constants.COMMON_CLOSE_NO_ITEM_CONTACT:
      return commonCloseNoItemContact(state, action);
    default:
      return state;
  }
}

function commonOpenAlert(state, action) {
  return Object.assign({}, state, {
    alertOpen: true,
    alertText: action.text,
    alertPrompt: action.prompt,
  });
}

function commonCloseAlert(state, action) {
  return Object.assign({}, state, {
    alertOpen: false,
    alertText: '',
    alertPrompt: null,
  });
}

function commonModalResize(state, action) {
  return Object.assign({}, state, {
    modalResize: state.modalResize + 0.1,
  });
}

function commonOpenContact(state, action) {
  return Object.assign({}, state, {
    contactOpen: true,
    contactNoItemOpen: false,
    inviteOpen: false,
    contactProduct: action.product,
  });
}

function commonCloseContact(state, action) {
  return Object.assign({}, state, {
    contactOpen: false,
    contactNoItemOpen: false,
    inviteOpen: false,
    contactProduct: null,
  });
}

function commonOpenInvite(state, action) {
  return Object.assign({}, state, {
    contactOpen: false,
    contactNoItemOpen: false,
    inviteOpen: true,
  });
}

function commonCloseInvite(state, action) {
  return Object.assign({}, state, {
    contactOpen: false,
    contactNoItemOpen: false,
    inviteOpen: false,
  });
}

function commonContactSent(state, action) {
  return Object.assign({}, state, {
    contactSent: true,
  });
}


function commonSetLastVisited(state, action) {
  return Object.assign({}, state, {
    lastPageVisited: action.page,
  });
}

function commonOpenNoItemContact(state, action) {
  return Object.assign({}, state, {
    contactOpen: false,
    contactNoItemOpen: true,
    inviteOpen: false,
  });
}

function commonCloseNoItemContact(state, action) {
  return Object.assign({}, state, {
    contactOpen: false,
    contactNoItemOpen: false,
    inviteOpen: false,
  });
}



// WEBPACK FOOTER //
// ./src/reducers/common.jsx